<script lang="ts">
  import { toastStore } from '$lib/toast/toast.svelte';
  import ToastList from './toastList.svelte';
</script>

<!-- Default toast host: a fixed container in the top-right, just under the main
     header. When a page mounts its own <ToastOutlet />, that outlet takes over
     and this stands down (see toastStore.activeOutlet). -->
{#if toastStore.activeOutlet === null}
  <div class="toastAnchor">
    <ToastList />
  </div>
{/if}

<style lang="scss">
  .toastAnchor {
    position: fixed;
    z-index: var(--z-index-toast);
    right: 20px;
    // Sit just under the main layout header (56px tall; see (admin)/Header.svelte),
    // keeping the same 20px gap used on the right.
    top: calc(56px + 20px);
  }
</style>
